import React from 'react';
import { Icon } from '../../common/commonModels';
import TileComponent from '../../components/utils/TileComponent';
import { PalletBox } from '../../models/pallet-box';

interface Props {
  title: string;
  palletBox: PalletBox;
  iconClassName: Icon;
  ageInHours: number;
}

// tslint:disable-next-line:function-name
export default function ShipmentsTileComponent({
  title,
  palletBox,
  iconClassName,
  ageInHours,
}: Props) {
  const ageFormatted =
    ageInHours > 48
      ? `${Math.floor(ageInHours / 24)} days old`
      : `${Math.floor(ageInHours)} hours old`;

  return (
    <TileComponent
      title={title}
      iconClassName={iconClassName}
      topRightLabelText={`${palletBox.shipmentCount}`}
      bottomRightIconClassName={ageInHours > 24 ? 'fa-clock-o text-danger' : undefined}
      bottomRightIconTitle={`Pallet box is ${ageFormatted}`}
    />
  );
}
